import React from 'react';
import { StickyTopBar } from '../components/StickyTopBar';
import { HeroSection } from '../components/HeroSection';
import { SceneSection } from '../components/SceneSection';
import { SolutionSection } from '../components/SolutionSection';
import { TransformSection } from '../components/TransformSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { WhatYouGetSection } from '../components/WhatYouGetSection';
import { PriceSection } from '../components/PriceSection';
import { FAQSection } from '../components/FAQSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { ClosingSection } from '../components/ClosingSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <main className="w-full min-h-screen" style={{
    background: '#0D1B2A'
  }} data-id="element-403">
      <StickyTopBar data-id="element-404" />
      <HeroSection data-id="element-405" />
      <SceneSection data-id="element-406" />
      <SolutionSection data-id="element-407" />
      <TransformSection data-id="element-408" />
      <TestimonialsSection data-id="element-409" />
      <WhatYouGetSection data-id="element-410" />
      <PriceSection data-id="element-411" />
      <FAQSection data-id="element-412" />
      <GuaranteeSection data-id="element-413" />
      <ClosingSection data-id="element-414" />
      <Footer data-id="element-415" />
    </main>;
}